import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Swipe from 'swipejs';
var ReactSwipe = /*#__PURE__*/function (_Component) {
  function ReactSwipe() {
    _classCallCheck(this, ReactSwipe);
    return _callSuper(this, ReactSwipe, arguments);
  }
  _inherits(ReactSwipe, _Component);
  return _createClass(ReactSwipe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.swipe = Swipe(this.containerEl, this.props.swipeOptions);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        childCount = _this$props.childCount,
        swipeOptions = _this$props.swipeOptions;
      var shouldUpdateSwipeInstance = prevProps.childCount !== childCount || prevProps.swipeOptions != swipeOptions;
      if (shouldUpdateSwipeInstance) {
        this.swipe.kill();
        this.swipe = Swipe(this.containerEl, this.props.swipeOptions);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.swipe.kill();
      this.swipe = void 0;
    }
  }, {
    key: "next",
    value: function next() {
      this.swipe.next();
    }
  }, {
    key: "prev",
    value: function prev() {
      this.swipe.prev();
    }
  }, {
    key: "slide",
    value: function slide() {
      var _this$swipe;
      (_this$swipe = this.swipe).slide.apply(_this$swipe, arguments);
    }
  }, {
    key: "getPos",
    value: function getPos() {
      return this.swipe.getPos();
    }
  }, {
    key: "getNumSlides",
    value: function getNumSlides() {
      return this.swipe.getNumSlides();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props2 = this.props,
        id = _this$props2.id,
        className = _this$props2.className,
        style = _this$props2.style,
        children = _this$props2.children;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        ref: function ref(el) {
          return _this.containerEl = el;
        },
        className: "react-swipe-container ".concat(className),
        style: style.container
      }, /*#__PURE__*/React.createElement("div", {
        style: style.wrapper
      }, React.Children.map(children, function (child) {
        if (!child) {
          return null;
        }
        var childStyle = child.props.style ? _objectSpread(_objectSpread({}, style.child), child.props.style) : style.child;
        return /*#__PURE__*/React.cloneElement(child, {
          style: childStyle
        });
      })));
    }
  }]);
}(Component);
_defineProperty(ReactSwipe, "propTypes", {
  swipeOptions: PropTypes.shape({
    startSlide: PropTypes.number,
    speed: PropTypes.number,
    auto: PropTypes.number,
    continuous: PropTypes.bool,
    disableScroll: PropTypes.bool,
    stopPropagation: PropTypes.bool,
    draggable: PropTypes.bool,
    swiping: PropTypes.func,
    callback: PropTypes.func,
    transitionEnd: PropTypes.func
  }),
  style: PropTypes.shape({
    container: PropTypes.object,
    wrapper: PropTypes.object,
    child: PropTypes.object
  }),
  id: PropTypes.string,
  className: PropTypes.string,
  childCount: PropTypes.number
});
_defineProperty(ReactSwipe, "defaultProps", {
  swipeOptions: {},
  style: {
    container: {
      overflow: 'hidden',
      visibility: 'hidden',
      position: 'relative',
      height: '100%'
    },
    wrapper: {
      overflow: 'hidden',
      position: 'relative',
      height: '100%',
      minHeight: '40vh'
    },
    child: {
      "float": 'left',
      width: '100%',
      position: 'relative',
      transitionProperty: 'transform'
    }
  },
  className: '',
  childCount: 0
});
export default ReactSwipe;